import React from 'react';
import CoachingHeading from 'coaching/components/CoachingHeading';
import EventTracking from 'lib/EventTracking';
import Image from 'components/Image';
import Link from 'components/Link';
import LinkConstants from 'constants/LinkConstants';
import Row from 'components/Row';
import Text from 'components/Text';

export default function CoachingSelfServeFailureView() {
  React.useEffect(() => {
    EventTracking.trackKey('coaching.self_schedule_purchase.failure.view');
  }, []);

  return (
    <Text align="center">
      <Row size="xxxlarge">
        <CoachingHeading>Sorry, something went wrong</CoachingHeading>
        <Text size="small">
          We couldn’t process your information. Please contact us at{' '}
          <Link weight="semibold" underline color="ink" href={LinkConstants.COACHING_EMAIL}>
            coaching@remind.com
          </Link>
        </Text>
      </Row>
      <Image src={require('assets/images/coaching/telescope_doodle.png')} />
    </Text>
  );
}
